import * as BranchKeys from 'automation-ui-action-features/constants/BranchKeys';
import BranchConnector from 'automation-ui-action-features/records/connection/BranchConnector';
import * as BranchConnectorKeys from 'automation-ui-action-features/constants/BranchConnectorKeys';
import * as ConnectorEdgeTypes from 'automation-ui-action-features/constants/ConnectorEdgeTypes';
import ConnectionTypes from 'automation-ui-action-features/constants/ConnectionTypes';
export const BranchMixinDefaultValues = {
  [BranchKeys.CONNECTION]: null
};
export function branchFromJSON({
  connection
}) {
  return {
    connection: connection && new BranchConnector(connection)
  };
}
function BranchMixin(superClass) {
  class BranchMixinClass extends superClass {
    getConnector() {
      return this.get(BranchKeys.CONNECTION);
    }
    setConnector(connector) {
      return this.set(BranchKeys.CONNECTION, connector);
    }
    updateConnector(updater) {
      return this.update(BranchKeys.CONNECTION, updater);
    }
    // Loop actions' sole branch must always have either an action
    // or a GO_TO back to the starting node
    sanitizeConnector({
      rootLoopNodeId
    }) {
      let connector = this.getConnector();
      if (rootLoopNodeId && !connector) {
        connector = new BranchConnector({
          [BranchConnectorKeys.NEXT_ACTION_ID]: rootLoopNodeId,
          [BranchConnectorKeys.EDGE_TYPE]: ConnectorEdgeTypes.GOTO,
          [BranchConnectorKeys.CONNECTION_TYPE]: ConnectionTypes.SINGLE_CONNECTION
        });
      }
      return this.setConnector(connector);
    }
  }
  return BranchMixinClass;
}
export default BranchMixin;